import { Select } from "@chakra-ui/react";
import { ColorIcon, colors } from "goi_common";
// import React from "react";

interface DropdownProps {
  name: string;
  value: string;
  onChange: any;
  values: Array<any>;
  className?: string;
  borderRadius?: string;
}

export function BorderDropdown({
  name,
  value,
  onChange,
  values,
}: // className,
// borderRadius,
DropdownProps) {
  return (
    <Select
      color={value ? "" : colors.gray700}
      border={`1px solid ${colors.gray200}`}
      className="body_16_r"
      fontSize={14}
      borderRadius="6px"
      value={value}
      onChange={onChange}
      icon={
        <ColorIcon
          name="icon-arrow-right-small-mono"
          size={16}
          color={colors.gray600}
          css={{ transform: "rotateZ(90deg)" }}
        />
      }
    >
      {values.length > 0 ? (
        <>
          <option value={""}>{name}</option>
          {values.map((res: any) => {
            return (
              <option key={res.value} value={res.value}>
                {res.key}
              </option>
            );
          })}
        </>
      ) : (
        <option value={0}>{name}</option>
      )}
    </Select>
  );
}
